import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f8c61bba&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style0 from "./Index.vue?vue&type=style&index=0&id=f8c61bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c61bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f8c61bba', component.options)
    } else {
      api.reload('f8c61bba', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=f8c61bba&scoped=true&", function () {
      api.rerender('f8c61bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/views/Customer/Cases/Open/Index.vue"
export default component.exports